import { createSelector } from 'reselect';

export const reviewOrderSelector = (state) => state.reviewOrderReducer;

export const selectAdyenPaymentMethods = createSelector(
  [reviewOrderSelector],
  (reviewOrder) => reviewOrder.paymentCardsAdyen ?? null
);
